module.exports = __webpack_public_path__ + "static/media/welcome.0dbd0cda.svg";